import type { ReactNode } from "react";

import { cx } from "../lib/cx";

/** 카드 — 원본 `app.css` 의 `.card`. `overflow-hidden` 이 내부 테이블의 모서리를 깎습니다. */
export function Card({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <div
      className={cx(
        "overflow-hidden rounded-[20px] border border-grey-100 bg-white shadow-soft",
        className,
      )}
    >
      {children}
    </div>
  );
}

/** 빈 상태 문구 — 원본 `app.css` 의 `.empty`. */
export function Empty({ children }: { children: ReactNode }) {
  return (
    <p className="px-[20px] py-[48px] text-center text-[14px] font-semibold text-grey-400">
      {children}
    </p>
  );
}
